import { Grid2 } from "@mui/material";
import React from "react";
import { useComponentSelection } from "../../Hooks/useComponentSelection";
import useObservedText from "../../Hooks/useObservedText";
import useViewOnOpen from "../../Hooks/useViewOnOpen";
import { GridContainerLayoutModel } from "../../Models/GridContainerLayoutModel";
import { GridContainerModel } from "../../Models/GridContainerModel";
import ComponentFactory from "../ComponentFactory";
import IComponentProps from "../IComponentProps";

const GridContainerComponent: React.FC<IComponentProps<GridContainerModel>> = ({ component, context, componentPath = [] }) => {
  const spacing = component.Spacing ?? 2;

  useViewOnOpen(component, context, "GridContainerComponent");

  const color = useObservedText(component.Color, context, "GridContainerComponent");
  const backgroundColor = useObservedText(component.BackgroundColor, context, "GridContainerComponent");

  const selectionProps = useComponentSelection({
    component,
    componentPath,
    isContainer: true,
    isEmpty: !component.Children || component.Children.length === 0,
  });

  return (
    <Grid2 container spacing={spacing} sx={{ overflow: "auto", color, backgroundColor }} {...selectionProps}>
      {component.Children?.map((child) => {
        const layout = child.Layout as GridContainerLayoutModel;
        const size = layout?.Size ?? 12;

        return (
          <Grid2 key={child.Id} size={size} sx={{ minWidth: 0, overflow: "auto" }}>
            <ComponentFactory parent={component} component={child} context={context} componentPath={[...componentPath, child.Id]} />
          </Grid2>
        );
      })}
    </Grid2>
  );
};

export default GridContainerComponent;
